unit Essentials.Web.BaseEditForm;

interface

uses
  {$IFNDEF PAS2JS}
  Winapi.Windows, Winapi.Messages,
  {$ENDIF}
  System.SysUtils, {$IFNDEF PAS2JS}System.Variants,{$ENDIF} System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WEBLib.Forms, WebForm.Core, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, Essentials.Web.Shared;

type
  TEssentialsBaseEditForm = class(TCoreWebForm)
    DataSource: TDataSource;
    CancelButton: TButton;
    EditButton: TButton;
    TitleBarLabel: TLabel;
    procedure CancelButtonClick(Sender: TObject);
    procedure EditButtonClick(Sender: TObject);
    procedure DataSourceDataChange(Sender: TObject; Field: TField);
  private
  const
    zSave = 'Save';
    zEdit = 'Edit';
  protected
    FEditMode: TEditMode;
    procedure SetEditMode(const Value: TEditMode); virtual;
    function AllRequiredFieldsAreSet: Boolean; virtual; abstract;
    procedure UpdateState;
  public
    procedure SetDataSources(aDataSet: TDataSet); overload;
    property EditMode: TEditMode read FEditMode write SetEditMode;

  protected procedure LoadDFMValues; override; end;

var
  EssentialsBaseEditForm: TEssentialsBaseEditForm;

implementation

uses StrUtils;

{$R *.dfm}

{ TEssentialsBaseEditForm }

procedure TEssentialsBaseEditForm.CancelButtonClick(Sender: TObject);
begin
  inherited;
  DataSource.Dataset.Cancel;
  ModalResult := mrCancel;
end;

procedure TEssentialsBaseEditForm.DataSourceDataChange(Sender: TObject;
  Field: TField);
begin
  inherited;
  UpdateState;
end;

procedure TEssentialsBaseEditForm.EditButtonClick(Sender: TObject);
begin
  inherited;
  if FEditMode <> None then
  begin
    ModalResult := mrOK;
  end
  else
    SetEditMode(Edit);
end;

procedure TEssentialsBaseEditForm.SetDataSources(aDataSet: TDataSet);
begin
  DataSource.DataSet := aDataset;
  DataSource.AutoEdit := False;
  UpdateState;
end;

procedure TEssentialsBaseEditForm.SetEditMode(const Value: TEditMode);
begin
  FEditMode := Value;

  if FEditMode <> None then
    DataSource.DataSet.Edit;

  UpdateState;
end;

procedure TEssentialsBaseEditForm.UpdateState;
var
  lCaption: string;
begin
  lCaption := IfThen(FEditMode <> None, zSave, zEdit);
  EditButton.Caption := lCaption;
  if Assigned(EditButton.ElementHandle) then
    EditButton.ElementHandle.setAttribute('aria-label', lCaption);
  EditButton.Enabled := (FEditMode = None) or (AllRequiredFieldsAreSet and (FEditMode <> None));
end;

procedure TEssentialsBaseEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TitleBarLabel := TLabel.Create('essentials.baseedit.titlebar');
  CancelButton := TButton.Create('essentials.baseedit.cancel.button');
  EditButton := TButton.Create('essentials.baseedit.edit.button');
  DataSource := TDataSource.Create(Self);

  TitleBarLabel.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  EditButton.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    Height := 143;
    ElementClassName := 'PopUpForm';
    TitleBarLabel.SetParentComponent(Self);
    TitleBarLabel.Name := 'TitleBarLabel';
    TitleBarLabel.Left := 8;
    TitleBarLabel.Top := 8;
    TitleBarLabel.Width := 20;
    TitleBarLabel.Height := 15;
    TitleBarLabel.Caption := 'Edit';
    TitleBarLabel.HeightPercent := 100.000000000000000000;
    TitleBarLabel.WidthPercent := 100.000000000000000000;
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 122;
    CancelButton.Top := 48;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 7;
    CancelButton.ElementClassName := 'btn btn-light';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    EditButton.SetParentComponent(Self);
    EditButton.Name := 'EditButton';
    EditButton.Left := 248;
    EditButton.Top := 48;
    EditButton.Width := 96;
    EditButton.Height := 25;
    EditButton.Caption := 'Edit';
    EditButton.ChildOrder := 7;
    EditButton.ElementClassName := 'btn btn-light';
    EditButton.ElementFont := efCSS;
    EditButton.ElementPosition := epIgnore;
    EditButton.HeightStyle := ssAuto;
    EditButton.HeightPercent := 100.000000000000000000;
    EditButton.WidthStyle := ssAuto;
    EditButton.WidthPercent := 100.000000000000000000;
    SetEvent(EditButton, Self, 'OnClick', 'EditButtonClick');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.AutoEdit := False;
    SetEvent(DataSource, Self, 'OnDataChange', 'DataSourceDataChange');
    DataSource.Left := 32;
    DataSource.Top := 40;
  finally
    TitleBarLabel.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    EditButton.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
